import Character from "@lss/common/src/shell/Character";


interface Player1INT {
}

const player1Properties: Player1INT = {
}

export const player1 = new Character<Player1INT>("Shirtless Player", player1Properties, "#6391FFFF");
